import { render, staticRenderFns } from "./SlideDown.vue?vue&type=template&id=167196ff&scoped=true&"
import script from "./SlideDown.js?vue&type=script&lang=js&"
export * from "./SlideDown.js?vue&type=script&lang=js&"
import style0 from "./SlideDown.scss?vue&type=style&index=0&id=167196ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167196ff",
  null
  
)

export default component.exports